(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof IntersectionObserver === 'undefined') return;

  // Only arms the CSS's hidden-then-fade-up state once we know we can
  // actually reveal it again — see the [html.novdat-reveal-active] rules
  // in snippets/novdat-visual-tokens.liquid for why this class is the gate.
  document.documentElement.classList.add('novdat-reveal-active');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('novdat-reveal--visible');
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.1, rootMargin: '0px 0px -80px 0px' }
  );

  const observeAll = (root = document) => {
    root.querySelectorAll('.novdat-reveal:not(.novdat-reveal--visible)').forEach((el) => observer.observe(el));
  };

  observeAll();

  // Theme editor swaps section markup back in via AJAX on every edit — re-scan
  // the reloaded section so its reveal still fires instead of staying hidden.
  document.addEventListener('shopify:section:load', (event) => observeAll(event.target));
})();
